import { Injectable } from '@angular/core';
import {throwError as observableThrowError,  Observable, of as observableOf } from 'rxjs';
import { map, catchError, debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { HttpParams } from '@angular/common/http';


import { ApiService } from './api.service';
import { ICustomers } from '../interfaces/customers';
import { ICustomer } from '../interfaces/customer';
import { IEvaluation } from '../interfaces/evaluation';
import { IEvaluations } from '../interfaces/evaluations';
import { IOrders } from '../interfaces/orders';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private _apiService: ApiService) {
  }

  search(arr: any) : Observable<ICustomers>  {
    let urlParams = new HttpParams()
    for(let i in arr) {
      urlParams = urlParams.set(i, arr[i].toString())
    }

    return this._apiService.doGET('customers', urlParams)
    .pipe(catchError(err => {
      return observableThrowError(err.error_message)
    }))
  }

  searchCustomers(title : Observable<string>, arr: any)  {
    return title
    .pipe(debounceTime(400))
    .pipe(distinctUntilChanged())
    .pipe(switchMap(title => {
      arr['search'] = title
      return this.search(arr)
    }));
  }

  getCustomerID(id: number) : Observable<ICustomer> {
    return this._apiService.doGET('customers/'+id)
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  getCustomerOrderID(id: number, arr: any) : Observable<IOrders> {
    let urlParams = new HttpParams()
    for(let i in arr) {
      urlParams = urlParams.set(i, arr[i].toString())
    }

    return this._apiService.doGET('customers/'+id+'/orders', urlParams)
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  getCustomerEvaluationID(id: number, arr:any) : Observable<IEvaluations> {
    let urlParams = new HttpParams()
    for(let i in arr) {
      urlParams = urlParams.set(i, arr[i].toString())
    }

    return this._apiService.doGET('customers/'+id+'/evaluation', urlParams)
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  getCustomersEvaluation(start_date, end_date): Observable<any>{
    start_date = new Date(start_date).toISOString().split('T')[0];
    end_date = new Date(end_date).toISOString().split('T')[0];
    return this._apiService.doGET('customers/evaluation?start_date=' + start_date + '&end_date=' + end_date)
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  getCustomersBadEvaluations(date): Observable<any>{
    return this._apiService.doGET('indicator/customers/bad-evaluations?start_date='+date)
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  getCustomersEvaluationByProps(pageSetup): Observable<any>{
    //Filtrar datas para formato esperado em back-end
    //=================================================================================
    pageSetup.start_date = new Date(pageSetup.start_date).toISOString().split('T')[0];
    pageSetup.end_date = new Date(pageSetup.end_date).toISOString().split('T')[0];
    return this._apiService.doGET('indicator/customers/evaluation?' +
      'topics=' + pageSetup.topics +
      '&page=' + pageSetup.page +
      '&limit=' + pageSetup.limit +
      '&start_date=' + pageSetup.start_date +
      '&end_date=' + pageSetup.end_date)
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  getTopics(pageSetup): Observable<any>{
    return this._apiService.doGET('indicator/customers/evaluation/topics?start_date=' + pageSetup.start_date +
    '&end_date=' + pageSetup.end_date)
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  getNpsGraphData(pageSetup): Observable<any>{
    return this._apiService.doGET('indicator/customers/evaluation/statistics?start_date=' + pageSetup.start_date +
    '&end_date=' + pageSetup.end_date)
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  blockCustomerID(id: number) {
    return this._apiService.doPATCH('customers/'+id+'/block')
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  unblockCustomerID(id: number) {
    return this._apiService.doPATCH('customers/'+id+'/unblock')
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  listCustomerAddress(id: number) {
    return this._apiService.doGET('customers/'+id+'/address')
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  deleteCustomerID(id: number) {
    return this._apiService.doDELETE('customers/'+id)
      .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  store(id: number, data) : Observable<ICustomer> {
    return this._apiService.doPATCH('customers/'+id, data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  storeAddress(id: number, data) : Observable<ICustomer> {
    return this._apiService.doPOST('customers/'+id+'/address', data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

}
